import PAGINATION from '@sdk/helpers/misc/pagination';

import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

export const INITIAL_SIMULATIONS_FILTERS = {
  _active: false,
  CRUDL_append: false,

  customer: '',
  sort: SORT_METHODS.created_at_desc.value,
  header_store_id: '',
  seller_ids: [],
  bank_codes: [],
  pre_approval_status: [],

  page: 1,
  per_page: PAGINATION.PER_PAGE,
  after: '',
  before: '',
};

const multiple = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/simulations`;
const single = `/${process.env.VUE_APP_BANKS_API_SUFFIX}/simulations/:uuid`;

const simulations = crudlModuleGenerator('simulations', {
  customKeys: {
    create: 'data',
    read: 'data',
    update: 'data',
    delete: 'data',
    list: 'data',
  },
  customEndpoints: {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
  },
});

export default {
  ...simulations,
  state: {
    ...simulations.state,
    list: {
      ...simulations.state.list,
      filters: {
        ...INITIAL_SIMULATIONS_FILTERS,
      },
    },
  },
  actions: {
    ...simulations.actions,
    internalList({ commit }, payload) {
      commit('_CRUDL/simulations/list/START');

      return new Promise((resolve, reject) => {
        client.get('/proposal_simulations', {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit('_CRUDL/simulations/list/SUCCESS', {
              data: {
                data: response.data.data.map(simulation => ({
                  ...simulation,
                  id: simulation.uuid,
                })),
              },
            });
            resolve(response);
          })
          .catch((error) => {
            commit('_CRUDL/simulations/list/FAILURE', error);
            reject(error);
          });
      });
    },
    internalRead({ commit }, payload) {
      commit('_CRUDL/simulations/read/START');

      return new Promise((resolve, reject) => {
        client.get(`/proposal_simulations/${payload.uuid}`, {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit('_CRUDL/simulations/read/SUCCESS', response);
            resolve(response);
          })
          .catch((error) => {
            commit('_CRUDL/simulations/read/FAILURE', error);
            reject(error);
          });
      });
    },
  },
};
